import { Environment } from './environment.interface';

export const environment: Environment = {
    production: true,
    auroraV1: "",
    env: "staging",
    baseUrl: "https://smstaging.instecservices.com",
    applicationEndpoint: "https://smstaging-api.instecservices.com",
    syncHost: "https://smstaging-sync.instecservices.com",
    documentationUrl: "https://smstaging-api-portal.instecservices.com",
    access_token: "access_token_staging",
    applicationInsights: "InstrumentationKey=dbc42a06-2a7d-4196-93e6-daa2a21316ec;IngestionEndpoint=https://eastus-5.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus.livediagnostics.monitor.azure.com/",
    auth: {
        authUri: "https://instec.auth0.com",
        clientId: "dv2KVntf3nbRdMPZV5PugQqVK6JDvP2I",
    },
    altLoginEnabled: "",
    altAuth: {
        authUri: "",
        clientId: ""
    },
    qlik: {
        authUrl: "https://uat1.insuritybi.insurity.com/sure-uw/hub/",
        reportsUrl: "https://uat1.insuritybi.insurity.com/sure-uw/sense/app/689ca289-b329-4ed7-acf1-fa1ae286a55d/sheet/0993752b-bfd7-4140-9513-96a140f11dde"
    },
    thoughtspot: {
        host: "https://insurity.thoughtspot.cloud"
    },
    ikcDocumentationUrl: "https://docs.insurity.com/category/insurityunderwriting",
    ikcIntegrationDocumentationUrl: "https://docs.insurity.com/bundle/SureUnderwritingUserHelp/page/webhooks.html",
    ikcBureauUrl: "https://docs.insurity.com/bundle/SureCommercialPolicy",
    requireAPIM: true,
    scpAuthClientId: "",
    ApiUrl: '',
    SaaS: true,
    SubscriptionKey: "",
    amplitude: {
        enabled: JSON.parse("false"),
        apiKey: "4880c04fc739e76053a1e13e2bbe4408",
    }
};
